import InfiniteScrollOriginal from 'react-infinite-scroll-component';

// Type assertion wrapper for React 19 compatibility
// react-infinite-scroll-component is not yet compatible with React 19
// This wrapper provides type compatibility until the library is updated
const InfiniteScroll = InfiniteScrollOriginal as any;

export default InfiniteScroll;
